import { useEffect, useState } from "react";
import { IGlobalNotification, IUser } from "@/common/services/types";
import { useUserStore } from "@/common/store/userStore";
import { loadUserData, loadLastSeenNotification } from "@/common/utils/storage";
import { apiMain } from "@/common/services";
import { isAuthenticated } from "@/common/services/Auth";

export const useGlobalNotification = () => {
  const { username, verified } = useUserStore((state) => state.currentUser);
  const [notification, setNotification] = useState<IGlobalNotification | undefined>(undefined);
  const [lastSeenNotificationId, setLastSeenNotificationId] = useState<string>(loadLastSeenNotification() || "0");

  useEffect(() => {
    (async() => {
      if (!await isAuthenticated()) {
        return;
      }

      try {
        const { id } = await apiMain.getLastSeenNotification();
        setLastSeenNotificationId(id);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  useEffect(() => {
    const userData = loadUserData() as IUser | null;
    const hasUserName = !!(username || userData?.username);

    let userType: "verified" | "unverified" | "anonymous" = "anonymous";

    if (hasUserName) {
      userType = (verified || userData?.verified) ? "verified" : "unverified";
    }

    const candidateNotifications = window.notifications?.global?.[userType];
    const candidateNotification = candidateNotifications && candidateNotifications.find((n) => n.id > lastSeenNotificationId);

    setNotification(candidateNotification);
  }, [username, verified, lastSeenNotificationId]);

  return { notification };
};

